module.exports = __webpack_public_path__ + "static/14-7adad5cfa898fcbf5effe099a481e765.jpg";